module.exports = __webpack_public_path__ + "img/oot.1a9d0d57.svg";